import React from 'react';

import classnames from 'classnames';

import QuickFilters from 'components/Filters/Common/QuickFilters';
import { COMPONENTS, SECTIONS } from 'components/Globals/Analytics/constants';
import Menu from 'components/Globals/Layout/Header/Menu';
import StickyHeader from 'components/Globals/Layout/Header/StickyHeader';
import ExploreMoreWrapper from 'components/Globals/Layout/StubPage/ExploreMore';

import { SORT_OPTION_VALUES, TP } from 'constants/index';

import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';
import useOnScrollBeyondElement from 'utils/hooks/useOnScrollBeyondElement';

import { useTranslation } from 'src/i18n';

import { FILTER_TYPES } from 'operabase-router/constants';

import FilterOptionListing from './Common/FilterOptionListing';
import FeaturedAgencies from './FeaturedAgencies';
import FeaturedArtists from './FeaturedArtists';
import FeaturedComposers from './FeaturedComposers';
import FeaturedOrganizations from './FeaturedOrganizations';
import FeaturedProductions from './FeaturedProductions';
import FeaturedTrending from './FeaturedTrending';
import HeroSection from './HeroSection';
import classes from './Homepage.module.scss';

const Homepage = () => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { isMobile } = useDeviceTypeLayouts();
  const { ref, isScrolledBeyond } = useOnScrollBeyondElement();

  return (
    <div>
      <section className={classes.heroBanner}>
        <HeroSection />
      </section>
      <div ref={ref} />
      <div className={classes.filters}>
        <QuickFilters
          filterType={FILTER_TYPES.SEASON}
          limit={15}
          collapsable={!isMobile}
          scrollable={isMobile}
          includeSpecialOptions
          enableCache
          trackingData={{
            section: SECTIONS.QUICK_FILTERS,
          }}
        />
      </div>
      <main className={classes.content}>
        <div className={classes.column}>
          <FeaturedProductions />
        </div>
        <div className={classnames(classes.column, classes.withFullWidth)}>
          <FeaturedArtists />
          <FeaturedComposers />
          <FeaturedOrganizations />
          <FeaturedAgencies />
        </div>
      </main>
      <section className={classnames(classes.section, classes.filters)}>
        <div>
          <QuickFilters
            filterType={FILTER_TYPES.WORK_TYPE}
            limit={15}
            collapsable={!isMobile}
            scrollable={isMobile}
            quickViewFilterOptionProps={{
              name: `${t(`${TP}.m_ALL`)} ${t(`${TP}.GENRES`)}`,
              variant: 'h2',
            }}
            showQuickViewFilterOption
            enableCache
            trackingData={{
              section: SECTIONS.QUICK_FILTERS,
              component: COMPONENTS.GENRES,
            }}
          />
        </div>
        <div>
          <QuickFilters
            filterType={FILTER_TYPES.SEASON}
            limit={15}
            collapsable={!isMobile}
            scrollable={isMobile}
            includeSpecialOptions
            enableCache
            trackingData={{
              section: SECTIONS.QUICK_FILTERS,
              component: COMPONENTS.SEASONS,
            }}
          />
        </div>
      </section>
      <section className={classnames(classes.section, classes.recommendations)}>
        <ExploreMoreWrapper isHomePage />
      </section>
      <section className={classnames(classes.section, classes.navigation)}>
        <Menu listingView />
      </section>
      <section className={classnames(classes.section, classes.trending)}>
        <FeaturedTrending />
      </section>
      <section className={classnames(classes.section, classes.genreListing)}>
        <FilterOptionListing
          filterType={FILTER_TYPES.WORK_TYPE}
          label={t(`${TP}.GENRES`)}
          enableCache
          trackingData={{
            section: SECTIONS.COLLAPSED_QUICK_FILTERS,
            component: COMPONENTS.GENRES,
          }}
        />
      </section>
      <section className={classnames(classes.section, classes.genreListing)}>
        <FilterOptionListing
          filterType={FILTER_TYPES.SEASON}
          label={t(`${TP}.m_SEASON`)}
          sort={SORT_OPTION_VALUES.YEAR_DESC}
          enableCache
          trackingData={{
            section: SECTIONS.COLLAPSED_QUICK_FILTERS,
            component: COMPONENTS.SEASONS,
          }}
        />
      </section>
      <StickyHeader isScrolledBeyond={isScrolledBeyond} />
    </div>
  );
};

export default Homepage;
